import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';
import { openAuthModal } from 'browser/services/microfrontendsAPI/header';

import { FavoritesFolders } from '../../components/FavoritesFolders';
import { useOfferCardContext } from '../../context';

export function FavoritesFoldersContainer() {
  const { user } = useOfferCardContext();

  const handleLogin = () => {
    void openAuthModal({
      alert: null,
      autoRefresh: true,
      source: null,
      useDefaultView: false,
      viewData: null,
    });
  };

  return (
    <FavoritesFolders>
      <FavoritesAssignWidgetContainer
        isAuthenticated={user.isAuthenticated}
        disableNotification={true}
        onWaitForLogin={handleLogin}
      />
    </FavoritesFolders>
  );
}
